import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { SidebarMenuItem } from '../sidebar-menu-item/component.js';
import { KebabCase } from '../../../utils/StringUtil.js';
import { parse } from 'url';
import { onExecuteKeyDown } from '../../../utils/KeyboardUtil.js';
import { FAIcon } from '../../fa-icon/component.js';

var SidebarMenuGroup = function SidebarMenuGroup(_ref) {
  var currentUrl = _ref.currentUrl,
      frontEndDomain = _ref.frontEndDomain,
      item = _ref.item,
      navigate = _ref.navigate,
      onSelect = _ref.onSelect,
      setCurrentUrl = _ref.setCurrentUrl,
      sidebarExpanded = _ref.sidebarExpanded;

  var getValidQueryString = function getValidQueryString(queryString) {
    var queryParams = queryString.replace('?', '').split('&');
    var newSearch = '?' + queryParams.reduce(function (newQuery, param) {
      var _param$split = param.split('='),
          _param$split2 = _slicedToArray(_param$split, 1),
          key = _param$split2[0];

      if (key !== 'force') {
        newQuery.push(param);
      }

      return newQuery;
    }, []).join('&');
    return newSearch === '?' ? '' : newSearch;
  };

  var getUrlPath = function getUrlPath(urlStr) {
    var urlObj = parse(urlStr);
    return {
      path: (urlObj === null || urlObj === void 0 ? void 0 : urlObj.pathname) + (urlObj.search ? getValidQueryString(urlObj.search) : ''),
      host: urlObj === null || urlObj === void 0 ? void 0 : urlObj.host
    };
  };

  var isSelectedItem = function isSelectedItem(item) {
    if (!item.target_url || !currentUrl) return;
    var currentUrlPath = getUrlPath(currentUrl);
    var targetUrlPath = getUrlPath(item.target_url);
    var isExactMatch = currentUrlPath.path === targetUrlPath.path && currentUrlPath.host === targetUrlPath.host;
    var isValidPath = targetUrlPath.path.split('/').filter(function (sub) {
      return sub;
    }).length > 1;
    var matchCondition = !(currentUrlPath.path.includes('dashboard') || currentUrlPath.path.includes('events')) && currentUrlPath.path.includes(targetUrlPath.path);
    return isExactMatch || isValidPath && matchCondition;
  };

  var hasSubmenuItems = function hasSubmenuItems() {
    return item && item.submenu_items && item.submenu_items.length > 0;
  };

  var handleSelect = function handleSelect() {
    onSelect(item);
  };

  var getClassName = function getClassName() {
    var showChildren = item.showChildren,
        submenu_items = item.submenu_items;
    var containsSelectedItem = submenu_items && submenu_items.some(isSelectedItem);
    var className = ['navgroup'];

    if (isSelectedItem(item)) {
      className.push('selected');
    }

    if (showChildren || containsSelectedItem) {
      className.push('expanded');
    }

    return className;
  };

  var id = item.id,
      submenu_items = item.submenu_items,
      target_url = item.target_url,
      title = item.title;

  if (!target_url && !hasSubmenuItems()) {
    return null;
  }

  var labelIcon = /*#__PURE__*/React.createElement(FAIcon, {
    icon: item.icon
  });
  var chevronIcon = hasSubmenuItems() && /*#__PURE__*/React.createElement(FAIcon, {
    icon: "angle-right",
    additionalClasses: "chevron"
  });
  var className = getClassName();
  var tooltip = /*#__PURE__*/React.createElement(Tooltip, {
    id: "tooltip"
  }, title);
  var overlay = /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "right",
    overlay: tooltip
  }, labelIcon);
  return /*#__PURE__*/React.createElement("div", {
    className: className.join(' '),
    key: title,
    "data-object-type": "sidebar-navigation",
    "data-object-action": "sidebar-".concat(KebabCase(title), "-").concat(hasSubmenuItems() ? 'expand' : 'select')
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "navgroup-label ui-default",
    onClick: handleSelect,
    onKeyDown: onExecuteKeyDown(handleSelect),
    tabIndex: 0
  }, chevronIcon, " ", sidebarExpanded ? labelIcon : overlay, " ", title), hasSubmenuItems() && /*#__PURE__*/React.createElement("ul", {
    className: "navgroup-list ui-default regular"
  }, submenu_items === null || submenu_items === void 0 ? void 0 : submenu_items.map(function (subitem) {
    return /*#__PURE__*/React.createElement(SidebarMenuItem, {
      frontEndDomain: frontEndDomain,
      navigate: navigate,
      item: subitem,
      key: subitem.title,
      onClickLink: setCurrentUrl,
      isSelected: isSelectedItem
    });
  })));
};

SidebarMenuGroup.displayName = "SidebarMenuGroup";
SidebarMenuGroup.displayName = 'SidebarMenuGroup';
export { SidebarMenuGroup };